// import React, { useEffect, useState } from "react";
// import { useParams, Link } from "react-router-dom";
// import "./CourseLevelPage.css";
// import RegisterButton from "../RegisterProtect/RegisterButton";
// import EnrollButton from "../EnrollLink/EnrollLink";
// import ReserveLink from "../ReserveLink/ReserveLink";
// import Payremaning from "../Payremaing/Payremaning";

// export default function CourseLevelPage() {
//   const { courseId } = useParams();
//   const [course, setCourse] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [profileData, setProfileData] = useState(null);

//   const conversionRate = 89; // 1 USD = 89 INR
//   const [levelPurchases, setLevelPurchases] = useState({}); // store by levelId

//   // Fetch course details
//   useEffect(() => {
//     fetch(`https://agepcoatings.com/getcourse/${courseId}`)
//       .then((res) => res.json())
//       .then((data) => {
//         if (!data.error) {
//           setCourse(data);
//         }
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Fetch error:", err);
//         setLoading(false);
//       });
//   }, [courseId]);

//   // Fetch user profile (isMember + country)
//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     if (user?.email) {
//       fetch(
//         `https://agepcoatings.com/getuserbyemail/${encodeURIComponent(user.email)}`
//       )
//         .then((res) => res.json())
//         .then((data) => {
//           if (data.success) {
//             setProfileData(data.data);
//           }
//         })
//         .catch((err) => console.error("Error fetching profile:", err));
//     }
//   }, []);

//   const isProfileComplete =
//     profileData?.country &&
//     profileData?.city &&
//     profileData?.state &&
//     profileData?.email;

//   // get the levels data - purchase collection
//   const levelPurchaseData = async (courseId, levelId) => {
//     const user = JSON.parse(localStorage.getItem("user"));

//     if (!user?.uid) return null;

//     try {
//       const response = await fetch(
//         `https://agepcoatings.com/payments/getcourseincart/${user.uid}/${courseId}/${levelId}`
//       );
//       const data = await response.json();

//       if (data.success) {
//         return data.item; // this is the object you showed
//       } else {
//         return null; // no item found
//       }
//     } catch (err) {
//       console.error("Error fetching purchase data:", err);
//       return null;
//     }
//   };

//   // fetch all level purchases
//   useEffect(() => {
//     const fetchAllLevelPurchases = async () => {
//       if (!course?.levelsData) return;
//       // console.log(course);
//       const purchases = {};
//       for (const level of course.levelsData) {
//         const item = await levelPurchaseData(course.courseId, level.levelId);
//         // console.log(item);
//         if (item) {
//           purchases[level.levelId] = item;
//         }
//       }

//       setLevelPurchases(purchases);
//     };

//     fetchAllLevelPurchases();
//   }, [course?.levelsData]);

//   // const getAmountData = (level) => {
//   //   const memberFeeINR = level?.member_fee ?? 0;
//   //   const nonMemberFeeINR = level?.nonmember_fee ?? 0;

//   //   // Logged out → always USD (converted)
//   //   if (!profileData) {
//   //     return {
//   //       isMember: false,
//   //       member: memberFeeINR,
//   //       nonMember: nonMemberFeeINR ,
//   //       currency: "USD",
//   //       symbol: "$",
//   //       locale: "en-US",
//   //     };
//   //   }

//   //   const isMember = profileData.isMember?.toLowerCase() === "yes";
//   //   const country = profileData.country?.toLowerCase();

//   //   if (country === "india") {
//   //     return {
//   //       isMember,
//   //       member: memberFeeINR  * conversionRate,
//   //       nonMember: nonMemberFeeINR * conversionRate,
//   //       currency: "INR",
//   //       symbol: "₹",
//   //       locale: "en-IN",
//   //     };
//   //   } else {
//   //     return {
//   //       isMember,
//   //       member: memberFeeINR * conversionRate,
//   //       nonMember: nonMemberFeeINR * conversionRate,
//   //       currency: "USD",
//   //       symbol: "$",
//   //       locale: "en-US",
//   //     };
//   //   }
//   // };

//   // ✅ For showing text in front end
//   const getAmountData = (level) => {
//     const memberFeeINR = level?.member_fee ?? 0;
//     const nonMemberFeeINR = level?.nonmember_fee ?? 0;

//     // Logged out → show both prices in USD
//     if (!profileData) {
//       return {
//         showBoth: true, // ✅ Important
//         member: memberFeeINR, // Member price
//         nonMember: nonMemberFeeINR, // Non-member price
//         currency: "USD",
//         symbol: "$",
//         locale: "en-US",
//       };
//     }

//     const isMember = profileData.isMember?.toLowerCase() === "yes";
//     const country = profileData.country?.toLowerCase();

//     if (country === "india") {
//       return {
//         showBoth: false,
//         isMember,
//         member: memberFeeINR * conversionRate,
//         nonMember: nonMemberFeeINR * conversionRate,
//         currency: "INR",
//         symbol: "₹",
//         locale: "en-IN",
//       };
//     } else {
//       return {
//         showBoth: false,
//         isMember,
//         member: memberFeeINR,
//         nonMember: nonMemberFeeINR,
//         currency: "USD",
//         symbol: "$",
//         locale: "en-US",
//       };
//     }
//   };

//   const renderPrice = (level) => {
//     const data = getAmountData(level);

//     const format = (amt) =>
//       new Intl.NumberFormat(data.locale, {
//         style: "currency",
//         currency: data.currency,
//         minimumFractionDigits: 2,
//       }).format(amt);

//     // Show both prices if logged out
//     if (data.showBoth) {
//       return (
//         <span>
//           <strong style={{color:"#101727"}}>Member: {format(data.member)}</strong>
//           {" | "}
//           <strong style={{color:"#101727"}}>Non-Member: {format(data.nonMember)}</strong>
//         </span>
//       );
//     }

//     // Logged in → show only the user's price
//     const amount = data.isMember ? data.member : data.nonMember;
//     return (
//       <span>
//         <strong>
//           {data.isMember ? "Member" : "Non-Member"} Price: {format(amount)}
//         </strong>
//       </span>
//     );
//   };

//   if (loading) return <p className="text-center my-5">Loading...</p>;
//   if (!course) return <p className="text-center my-5">Course not found</p>;

//   return (
//     <section className="courses-level-wrapper mb-5">
//       {/* Header */}
//       <div className="bg-inner-level-wrapper py-5">
//         <div className="container">
//           <div className="row align-items-center g-4">
//             <div className="col-lg-8">
//               <span className="btn badge-course border-0">
//                 {course?.courseLevelDetails.courseLevelbadge || "N/A"}
//               </span>
//               <h2 className="Pro-level mb-3">
//                 {course?.courseLevelDetails.courseLeveltitle}
//               </h2>
//               <p className="mb-3 fw-bold">
//                 {course?.courseLevelDetails.courseLevelsubtitle}
//               </p>
//               <p>{course?.courseLevelDetails.courseLeveldescription}</p>
//               <h5>
//                 <Link
//                   to="https://www.ampp.org/"
//                   target="_blank"
//                   style={{ textDecoration: "none", color: "#101727" }}
//                 >
//                   {course?.courseLevelDetails.courseLevelexternal_link_text}
//                 </Link>
//               </h5>
//               <div className="d-flex align-items-center flex-wrap mb-4 gap-3">
//                 <span>
//                   <i className="bi bi-star-fill text-warning"></i>{" "}
//                   {course?.courseLevelDetails.courseLevelrating || "0.0"}
//                 </span>
//                 <span>
//                   <i className="bi bi-bar-chart"></i>{" "}
//                   {course?.courseLevelDetails.courseLevellevels || 0} Levels
//                 </span>
//                 <RegisterButton className="btn btn-link fw-bold p-0" />
//               </div>
//             </div>
//             <div className="col-lg-4">
//               <div className="image-overlay-wrapper">
//                 <img
//                   src={
//                     course?.courseLevelDetails.courseLevelside_image ||
//                     "/placeholder.png"
//                   }
//                   alt={course?.courseLevelDetails.courseLevelside_title}
//                   className="course-card-img w-100 rounded-3"
//                 />
//                 <div className="side-image-bottm">
//                   <h6 className="fw-bold text-img-body">
//                     {course?.courseLevelDetails.courseLevelside_title}
//                   </h6>
//                   <RegisterButton className="custom-reg-btn border-0 w-100 mt-2" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* About Section */}
//       <div className="container py-5">
//         <div className="col-8 abt-section">
//           <h5 className="fw-bold">
//             {course?.courseLevelDetails.courseLevelsection_heading}
//           </h5>
//           <p>{course?.courseLevelDetails.courseLevelsection_description}</p>
//           <h6 className="fw-bold">
//             {course?.courseLevelDetails.courseLevelsection_subheading}
//           </h6>
//           <p>
//             {
//               course?.courseLevelDetails
//                 .courseLevelsection_subheading_description
//             }
//           </p>
//           <ul className="list-unstyled">
//             {course?.courseLevelDetails.courseLevelsection_pointer1 && (
//               <li>
//                 <i className="bi bi-check"></i>{" "}
//                 {course?.courseLevelDetails.courseLevelsection_pointer1}
//               </li>
//             )}
//             {course?.courseLevelDetails.courseLevelsection_pointer2 && (
//               <li>
//                 <i className="bi bi-check"></i>{" "}
//                 {course?.courseLevelDetails.courseLevelsection_pointer2}
//               </li>
//             )}
//             {course?.courseLevelDetails.courseLevelsection_pointer3 && (
//               <li>
//                 <i className="bi bi-check"></i>{" "}
//                 {course?.courseLevelDetails.courseLevelsection_pointer3}
//               </li>
//             )}
//             {course?.courseLevelDetails.courseLevelsection_pointer4 && (
//               <li>
//                 <i className="bi bi-check"></i>{" "}
//                 {course?.courseLevelDetails.courseLevelsection_pointer4}
//               </li>
//             )}
//           </ul>
//         </div>
//         {/* Levels Section */}
//         <div className="row g-4 mt-4">
//           {course?.levelsData?.map((level) => {
//             const data = getAmountData(level);
//             const priceForUser = data.isMember ? data.member : data.nonMember;
//             // console.log("Cevel data", course.levelsData);

//             const purchaseItem = levelPurchases[level.levelId]; // fetched purchase data
//             const mode = purchaseItem?.mode;
//             const status = purchaseItem?.status;
//             // console.log("purchaseItem", purchaseItem);

//             const isNonMember =
//               profileData && profileData.isMember?.toLowerCase() === "no";

//             return (
//               <div key={level.levelId} className="col-lg-4 col-md-6 d-flex">
//                 <div className="course-card-level border-0 shadow-sm d-flex flex-column h-100 w-100">
//                   <img
//                     src={level.levelimage || "/placeholder.png"}
//                     className="course-card-img-level mb-2"
//                     alt={level.levelbadge}
//                   />
//                   <div className="course-card-body-level d-flex flex-column flex-grow-1">
//                     <span className="badge text-dark border mb-2 course-level-badge">
//                       {level.level}
//                     </span>
//                     <h6 className="fw-semibold" style={{ color: "#101727" }}>{level.levelName}</h6>
//                     <p className="text-muted small flex-grow-1">
//                       {level.levelDescription}
//                     </p>

//                     {/* Price */}
//                     <span>{renderPrice(level)}</span>

//                     <div className="d-flex gap-2 mt-2">
//                       <Link
//                         to={`/courses/${courseId}/level/${level.levelId}`}
//                         className="learn-more-btn btn btn-outline text-center rounded-5 w-50"
//                         style={{ textDecoration: "none" }}
//                         state={{
//                           memberAmount: data.member,
//                           nonMemberAmount: data.nonMember,
//                           currency: data.currency,
//                           symbol: data.symbol,
//                           levelData: level,
//                         }}
//                       >
//                         Learn More
//                       </Link>
//                       {/* Conditionally render buttons */}
//                       {(!mode || mode === "partial") && (
//                         <div className="w-50">
//                           {mode !== "partial" && (
//                             <EnrollButton
//                               courseId={course.courseId}
//                               levelId={level.levelId}
//                               amount={priceForUser}
//                               currency={data.currency}
//                               courseTitle={course.courseName}
//                               levelbadge={level.levelbadge}
//                               disabled={!isProfileComplete} // ✅ disable if profile incomplete
//                             />
//                           )}
//                         </div>
//                       )}
//                     </div>

//                     {mode === "partial" && (
//                       <Payremaning
//                         courseId={course.courseId}
//                         levelId={level.levelId}
//                         amount={purchaseItem?.remainAmount}
//                         currency={data.currency}
//                         courseTitle={course.courseName}
//                         levelbadge={level.levelbadge}
//                         disabled={!isProfileComplete} // ✅ disable if profile incomplete
//                       />
//                     )}

//                     {/* ReserveLink: hide if partial/full purchased */}
//                     {mode !== "partial" && mode !== "full" && (
//                       <ReserveLink
//                         courseId={course.courseId}
//                         levelId={level.levelId}
//                         amount={priceForUser}
//                         currency={data.currency}
//                         courseTitle={course.courseName}
//                         levelbadge={level.levelbadge}
//                         disabled={!isProfileComplete} // ✅ disable if profile incomplete
//                       />
//                     )}

//                     {/* Already purchased message */}
//                     {((mode === "full" && status === "full") ||
//                       (mode === "remaining" && status === "full")) && (
//                       <div className="text-success mt-2">
//                         Already purchased this level
//                       </div>
//                     )}

//                     {/* Non-member promo message */}
//                     {isNonMember && (
//                       <div className="reserve-textlink mt-4">
//                         <strong>
//                           Gain more value with your training - AMPP Members
//                           receive additional discounts and member-only benefits.
//                         </strong>
//                         <br />
//                         <a
//                           href="https://www.ampp.org/membership"
//                           style={{ color: "#101727" }}
//                           target="_blank"
//                           rel="noreferrer"
//                         >
//                           Join now: www.ampp.org/membership
//                         </a>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </section>
//   );
// }

import React, { useEffect, useState, useMemo } from "react";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import "./CourseLevelPage.css";
import RegisterButton from "../RegisterProtect/RegisterButton";
import EnrollButton from "../EnrollLink/EnrollLink";
import ReserveLink from "../ReserveLink/ReserveLink";
import Payremaning from "../Payremaing/Payremaning";

export default function CourseLevelPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { courseId } = useParams();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [profileData, setProfileData] = useState(null);
  const [schedules, setSchedules] = useState([]);

  // const safeSchedules = Array.isArray(schedules) ? schedules : [];

  const conversionRate = 89; // 1 USD = 89 INR
  const [levelPurchases, setLevelPurchases] = useState({}); // store by levelId

  useEffect(() => {
    fetch("https://agepcoatings.com/eacschedule")
      .then((res) => res.json())

      .then((data) => {
        if (data.success) setSchedules(data.schedules || []);
      });
  }, []);

  // Fetch course details
  useEffect(() => {
    fetch(`https://agepcoatings.com/getcourse/${courseId}`)
      .then((res) => res.json())
      .then((data) => {
        if (!data.error) {
          setCourse(data);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setLoading(false);
      });
  }, [courseId]);

  // Fetch user profile (isMember + country)
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.email) {
      fetch(
        `https://agepcoatings.com/getuserbyemail/${encodeURIComponent(
          user.email,
        )}`,
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            setProfileData(data.data);
          }
        })
        .catch((err) => console.error("Error fetching profile:", err));
    }
  }, []);

  const isProfileComplete =
    profileData?.country &&
    profileData?.city &&
    profileData?.state &&
    profileData?.email;

  // get the levels data - purchase collection
  const levelPurchaseData = async (courseId, levelId) => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (!user?.uid) return null;

    try {
      const response = await fetch(
        `https://agepcoatings.com/payments/getcourseincart/${user.uid}/${courseId}/${levelId}`,
      );
      const data = await response.json();

      if (data.success) {
        return data.item; // this is the object you showed
      } else {
        return null; // no item found
      }
    } catch (err) {
      console.error("Error fetching purchase data:", err);
      return null;
    }
  };

  // fetch all level purchases
  useEffect(() => {
    const fetchAllLevelPurchases = async () => {
      if (!course?.levelsData) return;
      // console.log(course);
      const purchases = {};
      for (const level of course.levelsData) {
        const item = await levelPurchaseData(course.courseId, level.levelId);
        // console.log(item);
        if (item) {
          purchases[level.levelId] = item;
        }
      }

      setLevelPurchases(purchases);
    };

    fetchAllLevelPurchases();
  }, [course?.levelsData, course?.courseId]);

  // ✅ For showing text in front end
  const getAmountData = (level) => {
    const memberFeeINR = level?.member_fee ?? 0;
    const nonMemberFeeINR = level?.nonmember_fee ?? 0;

    // Logged out → show both prices in USD
    if (!profileData) {
      return {
        showBoth: true, // ✅ Important
        member: memberFeeINR, // Member price
        nonMember: nonMemberFeeINR, // Non-member price
        currency: "USD",
        symbol: "$",
        locale: "en-US",
      };
    }

    const isMember = profileData.isMember?.toLowerCase() === "yes";
    const country = profileData.country?.toLowerCase();

    if (country === "india") {
      return {
        showBoth: false,
        isMember,
        member: memberFeeINR * conversionRate,
        nonMember: nonMemberFeeINR * conversionRate,
        currency: "INR",
        symbol: "₹",
        locale: "en-IN",
      };
    } else {
      return {
        showBoth: false,
        isMember,
        member: memberFeeINR,
        nonMember: nonMemberFeeINR,
        currency: "USD",
        symbol: "$",
        locale: "en-US",
      };
    }
  };

  const renderPrice = (level) => {
    const data = getAmountData(level);

    const format = (amt) =>
      new Intl.NumberFormat(data.locale, {
        style: "currency",
        currency: data.currency,
        minimumFractionDigits: 2,
      }).format(amt);

    // Show both prices if logged out
    if (data.showBoth) {
      return (
        <span>
          <strong>Member: {format(data.member)}</strong>
          {" | "}
          <strong>Non-Member: {format(data.nonMember)}</strong>
        </span>
      );
    }

    // Logged in → show only the user's price
    const amount = data.isMember ? data.member : data.nonMember;
    return (
      <span>
        <strong>
          {data.isMember ? "Member" : "Non-Member"} Price: {format(amount)}
        </strong>
      </span>
    );
  };
  // normalize course name safely
  // const normalizeCourse = (str = "") =>
  //   String(str)
  //     .toLowerCase()
  //     .replace(/\(.*?\)/g, "")
  //     .replace(/program|certification/g, "")
  //     .replace(/[^a-z]/g, "")
  //     .trim(); // normalize course name safely

  const normalize = (str = "") =>
    String(str)
      .toLowerCase()
      .replace(/\(.*?\)/g, "") // remove (CP2), (CCI)
      .replace(/program|certification|level/g, "")
      .replace(/[^a-z]/g, "")
      .trim();



  // extract numeric level ( "2" , "CP Level 2" → 2 )
  // const getLevelNumber = (val) => {
  //   const m = String(val).match(/\d+/);
  //   return m ? Number(m[0]) : null;
  // };

  // const isStrictFutureDate = (startDate) => {
  //   if (!startDate) return false;

  //   let value = startDate;
  //   if (typeof startDate === "object" && startDate.$date) {
  //     value = startDate.$date;
  //   }

  //   const d = new Date(value);
  //   if (isNaN(d.getTime())) return false;

  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0);
  //   d.setHours(0, 0, 0, 0);

  //   return d > today;
  // };
  // const futureScheduleMap = useMemo(() => {
  //   const map = {};

  //   schedules.forEach((s) => {
  //     if (!s.courseName || !s.levelName || !s.startDate) return;

  //     const d = new Date(s.startDate);
  //     if (isNaN(d)) return;

  //     const today = new Date();
  //     today.setHours(0, 0, 0, 0);
  //     d.setHours(0, 0, 0, 0);

  //     if (d <= today) return;

  //     const courseKey = normalizeCourse(s.courseName);
  //     const levelNum = getLevelNumber(s.levelName);

  //     if (!courseKey || !levelNum) return;

  //     if (!map[courseKey]) map[courseKey] = new Set();
  //     map[courseKey].add(levelNum);
  //   });

  //   return map;
  // }, [schedules]);

  // const hasLevelSchedule = (level) => {
  //   if (!course || !level) return false;

  //   const courseKey = normalizeCourse(course.courseName);
  //   const levelNum = getLevelNumber(level.levelName || level.level);

  //   return futureScheduleMap[courseKey]?.has(levelNum) === true;
  // };

  const levelScheduleMap = useMemo(() => {
    const map = {};

    schedules.forEach((s) => {
      if (!s.courseName || !s.levelName || !s.startDate) return;

      const date = new Date(s.startDate?.$date || s.startDate);
      if (isNaN(date) || date <= new Date()) return;

      const courseKey = normalize(s.courseName);
      const levelKey = normalize(s.levelName);

      if (!map[courseKey]) {
        map[courseKey] = new Set();
      }

      map[courseKey].add(levelKey);
    });

    return map;
  }, [schedules]);

  const hasLevelSchedule = (level) => {
    if (!course || !level) return false;

    const courseKey = normalize(course.courseName);
    const levelKey = normalize(level.levelName || level.level);

    return levelScheduleMap[courseKey]?.has(levelKey) === true;
  };

  // Search rediract location
  useEffect(() => {
    if (!course) return;
    if (!location.state?.scrollToLevel) return;

    const timer = setTimeout(() => {
      const el = document.getElementById(location.state.scrollToLevel);
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 300); // wait for DOM render

    return () => clearTimeout(timer);
  }, [course, location.state]);

  if (loading) return <p className="text-center my-5">Loading...</p>;
  if (!course) return <p className="text-center my-5">Course not found</p>;

  return (
    <section className="courses-level-wrapper mb-5">
      {/* Header */}
      <div className="bg-inner-level-wrapper py-5">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-8">
              <span className="btn badge-course border-0">
                {course?.courseLevelDetails.courseLevelbadge || "N/A"}
              </span>
              <h2 className="Pro-level mb-3">
                {course?.courseLevelDetails.courseLeveltitle}
              </h2>
              <p className="mb-3 fw-bold">
                {course?.courseLevelDetails.courseLevelsubtitle}
              </p>
              <p>{course?.courseLevelDetails.courseLeveldescription}</p>
              <h5>
                <Link
                  to="https://www.ampp.org/"
                  target="_blank"
                  style={{
                    textDecoration: "none",
                    color: "#2308efff",
                  }}
                >
                  {course?.courseLevelDetails.courseLevelexternal_link_text}
                </Link>
              </h5>
              <div className="d-flex align-items-center flex-wrap mb-4 gap-3">
                <span>
                  <i className="bi bi-star-fill text-warning"></i>{" "}
                  {course?.courseLevelDetails.courseLevelrating || "0.0"}
                </span>
                <span>
                  <i className="bi bi-book"></i>{" "}
                  {course?.courseLevelDetails.courseLevellevels || 0} Levels
                </span>
                <RegisterButton className="btn btn-link fw-bold p-0" />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="image-overlay-wrapper">
                <img
                  src={
                    course?.courseLevelDetails.courseLevelside_image ||
                    "/placeholder.png"
                  }
                  alt={course?.courseLevelDetails.courseLevelside_title}
                  className="course-card-img w-100 rounded-3"
                />
                <div className="side-image-bottm">
                  <h6 className="fw-bold text-img-body">
                    {course?.courseLevelDetails.courseLevelside_title}
                  </h6>
                  <RegisterButton className="custom-reg-btn border-0 w-100 mt-2" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About Section */}
      <div className="container py-5">
        <div className="col-8 abt-section">
          <h5 className="fw-bold">
            {course?.courseLevelDetails.courseLevelsection_heading}
          </h5>
          <p>{course?.courseLevelDetails.courseLevelsection_description}</p>
          <h6 className="fw-bold">
            {course?.courseLevelDetails.courseLevelsection_subheading}
          </h6>
          <p>
            {
              course?.courseLevelDetails
                .courseLevelsection_subheading_description
            }
          </p>
          <ul className="list-unstyled">
            {course?.courseLevelDetails.courseLevelsection_pointer1 && (
              <li>
                <i className="bi bi-check"></i>{" "}
                {course?.courseLevelDetails.courseLevelsection_pointer1}
              </li>
            )}
            {course?.courseLevelDetails.courseLevelsection_pointer2 && (
              <li>
                <i className="bi bi-check"></i>{" "}
                {course?.courseLevelDetails.courseLevelsection_pointer2}
              </li>
            )}
            {course?.courseLevelDetails.courseLevelsection_pointer3 && (
              <li>
                <i className="bi bi-check"></i>{" "}
                {course?.courseLevelDetails.courseLevelsection_pointer3}
              </li>
            )}
            {course?.courseLevelDetails.courseLevelsection_pointer4 && (
              <li>
                <i className="bi bi-check"></i>{" "}
                {course?.courseLevelDetails.courseLevelsection_pointer4}
              </li>
            )}
          </ul>
        </div>
        {/* Levels Section */}
        <div className="row g-4 mt-md-4">
          {course?.levelsData?.map((level) => {
            const data = getAmountData(level);
            const priceForUser = data.isMember ? data.member : data.nonMember;
            // console.log("Cevel data", course.levelsData);

            const purchaseItem = levelPurchases[level.levelId]; // fetched purchase data
            const mode = purchaseItem?.mode;
            const status = purchaseItem?.status;
            console.log("purchaseItem", purchaseItem);

            const isNonMember =
              profileData && profileData.isMember?.toLowerCase() === "no";

            const showSchedule = hasLevelSchedule(level);

            return (
              <div key={level.levelId} className="col-lg-4 col-md-6 d-flex">
                <div
                  className="course-card-level border-0 shadow-sm d-flex flex-column h-100 w-100"
                  id={level.levelId}
                >
                  <img
                    src={level.levelimage || "/placeholder.png"}
                    className="course-card-img-level mb-2"
                    alt={level.levelbadge}
                  />

                  {/* ✅ FIXED SCHEDULE UI */}
                  <div className="d-flex schedule-txt">
                    <i
                      className={`bi ${
                        showSchedule ? "bi-calendar2" : "bi-clock"
                      } me-1`}
                      style={{ color: "#101727", fontSize: "14px" }}
                    ></i>

                    {showSchedule ? (
                      <span
                        style={{
                          cursor: "pointer",
                          color: "#101727",
                          fontSize: "14px",
                        }}
                        // onClick={() =>
                        //   navigate(
                        //     `/shadeule?course=${encodeURIComponent(
                        //       course.courseName,
                        //     )}&level=${encodeURIComponent(
                        //       getLevelNumber(level.levelName),
                        //     )}`,
                        //   )
                        // }
                         onClick={() =>
                          navigate(
                            `/shadeule?course=${encodeURIComponent(course.courseName)}
                            &level=${encodeURIComponent(level.levelName)}`,
                          )
                        }
                      >
                        Check Schedule
                      </span>
                    ) : (
                      <span
                        style={{
                          color: "#101727",
                          fontSize: "14px",
                        }}
                      >
                        Coming Soon
                      </span>
                    )}
                  </div>
                  <div className="course-card-body-level d-flex flex-column flex-grow-1">
                    <span className="badge text-dark border mb-2 course-level-badge">
                      {level.level}
                    </span>
                    <h6 style={{ color: "#101727" }}>{level.levelName}</h6>
                    <p className="text-muted small flex-grow-1">
                      {level.levelDescription}
                    </p>

                    {/* Price */}
                    <span>{renderPrice(level)}</span>

                    <div className="d-flex gap-2 mt-2">
                      <Link
                        to={`/courses/${courseId}/level/${level.levelId}`}
                        className="learn-more-btn btn btn-outline text-center rounded-5 w-50"
                        style={{ textDecoration: "none" }}
                        state={{
                          memberAmount: data.member,
                          nonMemberAmount: data.nonMember,
                          currency: data.currency,
                          symbol: data.symbol,
                          levelData: level,
                        }}
                      >
                        Learn More
                      </Link>
                      {/* Conditionally render buttons */}
                      {(!mode || mode === "partial") && (
                        <div className="w-50">
                          {mode !== "partial" && (
                            <EnrollButton
                              courseId={course.courseId}
                              levelId={level.levelId}
                              amount={priceForUser}
                              currency={data.currency}
                              courseTitle={course.courseName}
                              levelbadge={level.levelbadge}
                              disabled={!isProfileComplete} // ✅ disable if profile incomplete
                            />
                          )}
                        </div>
                      )}
                    </div>

                    {mode === "partial" && (
                      <Payremaning
                        courseId={course.courseId}
                        levelId={level.levelId}
                        amount={purchaseItem?.remainAmount}
                        currency={data.currency}
                        courseTitle={course.courseName}
                        levelbadge={level.levelbadge}
                        disabled={!isProfileComplete} // ✅ disable if profile incomplete
                      />
                    )}

                    {/* ReserveLink: hide if partial/full purchased */}
                    {mode !== "partial" && mode !== "full" && (
                      <ReserveLink
                        courseId={course.courseId}
                        levelId={level.levelId}
                        amount={priceForUser}
                        currency={data.currency}
                        courseTitle={course.courseName}
                        levelbadge={level.levelbadge}
                        disabled={!isProfileComplete} // ✅ disable if profile incomplete
                      />
                    )}

                    {/* Already purchased message */}
                    {((mode === "full" && status === "full") ||
                      (mode === "remaining" && status === "full")) && (
                      <div className="text-success mt-2">
                        Already purchased this level
                      </div>
                    )}

                    {/* Non-member promo message */}
                    {isNonMember && (
                      <div className="reserve-textlink mt-4">
                        <strong>
                          Gain more value with your training - AMPP Members
                          receive additional discounts and member-only benefits.
                        </strong>
                        <br />
                        <a
                          href="https://www.ampp.org/membership"
                          style={{ color: "#101727" }}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Join now: www.ampp.org/membership
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
